import {request } from "../../api/api"

export const userLogout = () => {
    return request.post('/logout/')
}

